








import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name:"SlidingPanel",
    components: {

    },
})
export default class SlidingPanel extends Vue {
    @Prop({ required: true }) public id: string;
    @Prop({ required: false }) public isFullHeight: boolean;
    @Prop({ required: false }) public enterFrom: string;
    @Prop({ required: false }) public panelWidth: string | number;

    public get classes() {
        return {
            ['powerbar-sliding-panel']: true,
            [`powerbar-sliding-panel--enter-${this.enterFrom}`]: true,
            [`powerbar-sliding-panel--is-full-height`]: this.isFullHeight,
        };
    }
}
